__webpack_require__.p = "https://pentagonuiresources.blob.core.windows.net/website-embedded-elements/indoor-promo-product-spotlight/";